<template>
  <div>
    <PageAppBar>New User</PageAppBar>
    <div class="page-content header-clear-small">
      <div class="card card-style">
        <div class="input-style has-icon input-style-1 input-required">
          <span>Full Name</span>
          <em>(required)</em>
          <input v-model="name" placeholder="Full Name" type="text">
        </div>
        <div class="input-style has-icon input-style-1 input-required">
          <span>Email</span>
          <input v-model="email" placeholder="Email" type="email">
        </div>
        <div class="input-style has-icon input-style-1 input-required">
          <span>Phone number</span>
          <em>(required)</em>
          <input v-model="phone_number" placeholder="Phone number" type="tel">
        </div>
        <p class="btn btn-m btn-full rounded-s shadow-l bg-green1-dark text-uppercase font-900" @click="saveUser">Save
          Account</p>
      </div>
    </div>
  </div>
</template>

<script>
import PageAppBar from "@/components/PageAppBar";
import axios from "axios";
import global from "@/mixins/global";

export default {
  mixins: [global],
  name: "AdminCreateUser",
  components: {PageAppBar},
  data() {
    return {
      name: "",
      email: "",
      phone_number: ""
    }
  },
  methods: {
    saveUser() {
      axios.post(this.base_url + "register", {
        name: this.name,
        email: this.email,
        phone_number: this.phone_number,
        password: "password"
      }, this.requestHeader())
          .then(response => {
            if (Object.keys(response).length) {
              this.$router.back()
            }

          }).catch(error => {
        this.error = error
      })
    }
  }
}
</script>

<style scoped>

</style>